// extracted by mini-css-extract-plugin
export default {"transfer_container":"ProductosIncentivos_transfer_container__cEUKB","card":"ProductosIncentivos_card__6qKRp"};